import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import experiments from '@reverbdotcom/commons/src/experiments';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';

export const BOOSTED_USER_COUNTRY_CODES = [
  'AT', // Austria
  'DE', // Germany
  'ES', // Spain
  'FI', // Finland
  'IE', // Ireland
  'PL', // Poland
];

export const BUMPED_ITEM_REGIONS = [
  'GB', // United Kingdom
  'DE', // Germany
  'ES', // Spain
  'FR', // France
  'IT', // Italy
  'CA', // Canada
  'AU', // Australia
];

export function bumpedItemRegion(user: Partial<IUser>) {
  if (
    !!user.countryCode &&
    BUMPED_ITEM_REGIONS.includes(user.countryCode) &&
    isExperimentEnabled(user, experiments.BOOST_MARKETPLACE_SELLER_LOCATION_V3)
  ) {
    return user.countryCode;
  }

  return undefined;
}

export function boostedUserCountryCode(user: Partial<IUser>) {
  if (
    !!user.countryCode &&
    (BOOSTED_USER_COUNTRY_CODES.includes(user.countryCode) || isExperimentEnabled(user, experiments.BOOST_MARKETPLACE_SELLER_LOCATION_V3))
  ) {
    return user.countryCode;
  }

  return '';
}
